var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L31.843 0L31.843 32L0 32L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L31.843 0L31.843 32L0 32L0 0Z",
    id: "Clip-2",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.981 0C20.225 0 24.206 1.65 27.2 4.65L27.199 4.65C30.193 7.65 31.843 11.631 31.843 15.869C31.843 24.612 24.725 31.725 15.987 31.725L15.981 31.725C13.331 31.725 10.725 31.056 8.406 29.794L0 32L2.25 23.781C0.862 21.381 0.131 18.65 0.131 15.856C0.131 7.112 7.243 0 15.981 0ZM15.988 29.05C13.619 29.05 11.3 28.413 9.275 27.213L8.794 26.925L3.807 28.231L5.138 23.368L4.825 22.868C3.5 20.774 2.806 18.349 2.806 15.856C2.806 8.587 8.718 2.675 15.994 2.675C19.513 2.675 22.825 4.05 25.313 6.537C27.801 9.031 29.169 12.337 29.169 15.862C29.163 23.137 23.25 29.05 15.988 29.05ZM20.507 17.887C20.869 18.019 22.819 18.975 23.213 19.175L23.215 19.174C23.615 19.374 23.877 19.474 23.971 19.649C24.071 19.811 24.071 20.605 23.74 21.53C23.409 22.455 21.827 23.298 21.065 23.411C20.384 23.511 19.521 23.555 18.571 23.255C17.996 23.068 17.259 22.824 16.315 22.418C12.34 20.706 9.746 16.699 9.546 16.437C9.346 16.168 7.927 14.287 7.927 12.337C7.927 10.387 8.951 9.425 9.314 9.031C9.676 8.637 10.108 8.537 10.37 8.537C10.632 8.537 10.895 8.537 11.126 8.549C11.1547 8.55041 11.1845 8.55019 11.2154 8.54996L11.2155 8.54996C11.4477 8.54825 11.7385 8.54611 12.02 9.23C12.345 10.024 13.139 11.974 13.239 12.174C13.339 12.374 13.401 12.606 13.27 12.868C13.138 13.136 13.076 13.299 12.876 13.53C12.676 13.761 12.463 14.049 12.282 14.224C12.082 14.417 11.876 14.636 12.107 15.03C12.338 15.424 13.138 16.724 14.313 17.774C15.826 19.124 17.107 19.543 17.501 19.743C17.895 19.943 18.126 19.905 18.357 19.643C18.588 19.375 19.351 18.481 19.613 18.087C19.882 17.687 20.145 17.755 20.507 17.887Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWhatsapp);
export default __webpack_public_path__ + "static/media/ico-whatsapp.bae575a3a44cfa3ce0e8467bca741e3b.svg";
export { ForwardRef as ReactComponent };